<template>
    <div class="flex items-center gap-1" :data-cy="`attachments-transaction-${params.data.transactionUuid}`">
        <div v-if="attachments.length">
            <i class="i-ph-files inline-block text-lg -mb-1"/>
            Vedlegg
        </div>
        <template v-if="attachments.length">
            <template v-if="attachments.length <= 5">
                <UBadge
                    v-for="(attUuid, counter) in attachments"
                    :key="attUuid"
                    :class="[
                        isHoverToOpenDocumentPreviewModal ? 'cursor-zoom-in' : 'cursor-pointer'
                    ]"
                    :variant="attUuid === selectedDocumentMetaUuid ? 'solid' : 'outline'"
                    color="primary"
                    @click="onClickDocumentLink(attUuid)"
                    @mouseover="onHoverDocumentLink(attUuid)"
                >
                    {{ counter + 1 }}
                </UBadge>
            </template>
            <transaction-link v-else :transaction-uuid="params.data.transactionUuid">
                <UBadge
                    variant="outline"
                    color="primary"
                    class="cursor-pointer"
                >
                    {{ attachments.length }} vedlegg
                </UBadge>
            </transaction-link>
        </template>
    </div>
</template>

<script setup lang="ts">

import {computed, provide} from 'vue'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import TransactionLink from '@/transaction/TransactionLink.vue'

const {onClickDocumentLink, onHoverDocumentLink, isHoverToOpenDocumentPreviewModal, selectedDocumentMetaUuid} = useDocumentPreviewModalService()

type AttachmentUuid = string

const props = defineProps({
    params: {
        type: Object as () => {
            data: {
                attachments: AttachmentUuid[],
                transactionUuid: string
            },
            context: {
                activatePopup: Function,
                panelId: Number,
                panelPathSegment: String
            },
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const attachments = computed(() => {
    return props.params.data.attachments
})

</script>

<style scoped>

</style>